<template>
  <div :class="classes">
    <pt-form-item label="客户姓名" :required="true" :labelWidth="labelWidth">
      <el-input v-model="form.name"  name="name" v-validate="'required'" data-vv-as="客户姓名" placeholder="请输入客户姓名"></el-input>
    </pt-form-item>
    <pt-form-item label="称谓" :labelWidth="labelWidth">
      <gender-selector v-model="form.gender" type="title"></gender-selector>
    </pt-form-item>
    <pt-form-item label="样本条码号" :required="true" :labelWidth="labelWidth">
      <el-input v-model="form.sampleId"  name="sampleId" v-validate="'required'" data-vv-as="样本条码号" placeholder="请输入样本条码号"></el-input>
    </pt-form-item>
    <pt-form-item label="检测套餐" :required="true" :labelWidth="labelWidth">
      <gender-selector v-model="form.gender" type="title"></gender-selector>
    </pt-form-item>
    <pt-form-item label="联系电话" :required="true" :labelWidth="labelWidth">
      <el-input v-model="form.sampleId"  name="sampleId" v-validate="'required'" data-vv-as="样本条码号" placeholder="请输入联系电话"></el-input>
    </pt-form-item>
    <pt-form-item label="申请时间" :required="true" :labelWidth="labelWidth">
      <el-date-picker v-model="form.applyDate" type="date" placeholder="选择日期"></el-date-picker>
    </pt-form-item>
    <pt-form-item label="备注" :required="true" :labelWidth="labelWidth">
      <el-input type="textarea" :autosize="{ minRows: 3, maxRows: 6 }" v-model="form.desc"></el-input>
    </pt-form-item>
    <div class="form-buttons">
      <el-button type="primary">提&nbsp;&nbsp;交</el-button>
      <el-button type="primary" plain>取&nbsp;&nbsp;消</el-button>
    </div>
  </div>
</template>

<script>
import formMixins from 'mixins/form'
import genderSelector from 'cps/base/selector/gender-selector'
// 组件class前缀
const prefixCls = 'pt-apply-form'

export default {
  name: 'pt-apply-form',
  mixins: [formMixins],
  computed: {
    classes () {
      return `${prefixCls}`
    }
  },
  components: {
    genderSelector
  },
  data () {
    return {
      labelWidth: '80px',
      form: {

      }
    }
  }
}
</script>

<style lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */
.pt-apply-form{
  width:500px;
  .el-date-editor.el-input{
    width:100%;
  }
}
</style>
